// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FEgf","type":"styles_type__1f57g","choices":"styles_choices__2oN_i"};